import React from 'react';
import PropTypes from 'prop-types';
import '../assets/styles.css'

const AgentJoinedDivider = ({ content }) => {
    return (
        <div className='_kanis_divider'>
            {`${content || "You are now speaking with an agent"}`}
        </div>
    );
}

export default AgentJoinedDivider;

AgentJoinedDivider.propTypes = {
    content: PropTypes.string
};